import { type ReactNode } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { MagnifyingGlassIcon, XSmallCircleColorIcon } from '@/icons';
import { ClassroomSortDropdown, type ClassroomSortMode } from '@/pages/classrooms/shared/components/ClassroomSortDropdown';
import { IconButton, TextField } from '@/ui_v3';
import { cn } from '@/utils';
export type ClassroomListSortMode = ClassroomSortMode;
export function ClassroomSearchField({
  className,
  searchText,
  autoFocus,
  onSearchTextChange
}: {
  className?: string;
  searchText: string;
  autoFocus?: boolean;
  onSearchTextChange: (value: string) => void;
}) {
  const {
    t
  } = useTranslation(['classroom']);
  return <div className={cn('min-w-0 max-w-[400px] flex-1', className)} data-sentry-component="ClassroomSearchField" data-sentry-source-file="ClassroomListSearchToolbar.tsx">
      <TextField value={searchText} onChange={e => onSearchTextChange(e.target.value)} placeholder={t('classroom:classroomListSearchToolbar.searchPlaceholder')} intent="strong" autoFocus={autoFocus} required className="w-full" rightSlot={<div className="flex items-center gap-sm laptop-sm:gap-xs">
            {searchText && <IconButton type="button" variant="transparent" intent="neutral" size="md" aria-label={t('classroom:classroomListSearchToolbar.clearSearchAriaLabel')} onClick={() => onSearchTextChange('')}>
                <XSmallCircleColorIcon size="md" />
              </IconButton>}
            <MagnifyingGlassIcon size="md" fill={ICON_COLOR.neutral} />
          </div>} data-sentry-element="TextField" data-sentry-source-file="ClassroomListSearchToolbar.tsx" />
    </div>;
}
export function ClassroomListSearchToolbar({
  filteredItemCount,
  isFetchingSortOrder,
  searchText,
  sortMode,
  leading,
  onChangeSortMode,
  onSearchTextChange
}: {
  filteredItemCount: number;
  isFetchingSortOrder: boolean;
  searchText: string;
  sortMode: ClassroomListSortMode;
  leading?: ReactNode;
  onChangeSortMode: (mode: ClassroomListSortMode) => void;
  onSearchTextChange: (value: string) => void;
}) {
  const {
    t
  } = useTranslation(['classroom']);
  return <div className="flex flex-col gap-sm" data-sentry-component="ClassroomListSearchToolbar" data-sentry-source-file="ClassroomListSearchToolbar.tsx">
      <div className={cn('flex items-center justify-between gap-xs pb-xs mobile-lg:gap-sm', !leading && 'max-mobile-lg:justify-end')}>
        {leading ? <div className="min-w-0 shrink-0">{leading}</div> : null}
        <div className="flex min-w-0 flex-1 items-center justify-end gap-md">
          <ClassroomSearchField searchText={searchText} onSearchTextChange={onSearchTextChange} className="max-mobile-lg:hidden" data-sentry-element="ClassroomSearchField" data-sentry-source-file="ClassroomListSearchToolbar.tsx" />
          <ClassroomSortDropdown countLabel={t('classroom:classroomList.countLabel', {
          count: filteredItemCount
        })} sortMode={sortMode} onChangeSortMode={onChangeSortMode} disabled={isFetchingSortOrder} data-sentry-element="ClassroomSortDropdown" data-sentry-source-file="ClassroomListSearchToolbar.tsx" />
        </div>
      </div>
    </div>;
}